// Web Audio synthesised notification sounds + a global on/off flag.
// Sound is OFF by default and requires a user gesture (the header toggle) to enable,
// which both flips the flag and resumes the AudioContext (browser autoplay policy).

let ctx = null;
let enabled = typeof window !== "undefined" && localStorage.getItem("notif_sound") === "on";

export const isSoundEnabled = () => enabled;

const ensureCtx = () => {
  const Ctor = window.AudioContext || window.webkitAudioContext;
  if (!Ctor) return null;
  if (!ctx) ctx = new Ctor();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

export const setSoundEnabled = (on) => {
  enabled = on;
  localStorage.setItem("notif_sound", on ? "on" : "off");
  if (on) ensureCtx();
  window.dispatchEvent(new CustomEvent("notif:sound", { detail: on }));
};

// Resume the context on any user gesture so a previously-enabled setting keeps working.
if (typeof window !== "undefined") {
  const resume = () => { if (enabled) ensureCtx(); };
  window.addEventListener("pointerdown", resume, { passive: true });
  window.addEventListener("keydown", resume);
}

const note = (c, freq, start, dur, type = "triangle", peak = 0.18) => {
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  osc.connect(gain);
  gain.connect(c.destination);
  const t = c.currentTime + start;
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.linearRampToValueAtTime(peak, t + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  osc.start(t);
  osc.stop(t + dur + 0.02);
};

// Triumphant ascending fanfare ending on a bright major chord.
export const playWinFanfare = () => {
  if (!enabled) return;
  const c = ensureCtx();
  if (!c) return;
  const melody = [[523.25, 0, 0.16], [659.25, 0.14, 0.16], [783.99, 0.28, 0.16], [1046.5, 0.42, 0.45]];
  melody.forEach(([f, s, d]) => note(c, f, s, d, "sawtooth", 0.16));
  [523.25, 659.25, 783.99, 1046.5].forEach((f) => note(c, f, 0.42, 0.6, "triangle", 0.1));
};

// Soft two-tone chime for an incoming support ticket.
export const playTicketChime = () => {
  if (!enabled) return;
  const c = ensureCtx();
  if (!c) return;
  note(c, 880, 0, 0.16, "sine", 0.14);
  note(c, 1174.66, 0.13, 0.26, "sine", 0.12);
};

// Opgewekt drietoons-belletje voor een nieuw toegewezen taak.
export const playTaskChime = () => {
  if (!enabled) return;
  const c = ensureCtx();
  if (!c) return;
  note(c, 659.25, 0, 0.14, "triangle", 0.16);
  note(c, 830.61, 0.12, 0.14, "triangle", 0.16);
  note(c, 987.77, 0.24, 0.32, "triangle", 0.14);
};
